import { render, staticRenderFns } from "./ParcelReport.vue?vue&type=template&id=cd90b8dc&scoped=true&"
import script from "./ParcelReport.vue?vue&type=script&lang=js&"
export * from "./ParcelReport.vue?vue&type=script&lang=js&"
import style0 from "./ParcelReport.vue?vue&type=style&index=0&id=cd90b8dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd90b8dc",
  null
  
)

export default component.exports